import React from 'react';
import Link from '@material-ui/core/Link';
import { Translate } from 'react-redux-i18n';

const DVR_TOOLKIT_URL = process.env.REACT_APP_DVRTOOLKIT_URL;

const DvrToolkitPage = () => {
  return (
    <div className="bodycontent dvrToolkit__geotab_wrapper">
      <Translate value="dvrToolkit.newTabMessage" />
      &nbsp;
      <Link href={DVR_TOOLKIT_URL} target="_blank" rel="noreferrer">
        DVR Toolkit
      </Link>
    </div>
  );
};

export default DvrToolkitPage;
